<script setup lang="ts">
/**
 * A labelled group inside an action section: a muted sub-heading, an optional
 * `header` slot at its end and the actions below. The kit version of the ERP's
 * `actions/Subsection.vue`, with the same props and slots.
 */
defineProps<{ labelText: string }>();

defineSlots<{
  default?: () => unknown;
  header?: () => unknown;
}>();
</script>

<template>
  <div class="nx-action-subsection" role="group" :aria-label="labelText">
    <div class="nx-action-subsection__head">
      <span class="nx-action-subsection__label">{{ labelText }}</span>
      <span v-if="$slots.header" class="nx-action-subsection__extra"><slot name="header" /></span>
    </div>
    <div class="nx-action-subsection__body">
      <slot />
    </div>
  </div>
</template>

<style scoped>
.nx-action-subsection {
  display: flex;
  flex-direction: column;
  padding-block-start: var(--nxt-space-xs);
}
.nx-action-subsection__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--nxt-space-xs);
  color: var(--nxt-fg-muted);
  font-weight: var(--nxt-font-weight-medium);
}
.nx-action-subsection__label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.nx-action-subsection__extra {
  display: inline-flex;
  flex: 0 0 auto;
  padding-inline-end: var(--nxt-space-2xs);
}
.nx-action-subsection__body {
  display: flex;
  flex-direction: column;
  gap: var(--nxt-space-2xs);
  padding-block-start: var(--nxt-space-xs);
}
</style>
